import React from 'react'
import '../styles/Footer.css'
import Socails from './Socails'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
export default function Footer() {
  return (
    <div className='footer_container'>
        <section id="subscribe_btn"><span>Subscribe</span></section>
        <p>This web site is the intellectual property of Brewing ink .</p>
        <p>ALL RIGHTS ARE RESERVED</p>
       <p><Socails/></p>
        <p><LocalPhoneIcon/> : +91 (9869141685) , +91 (6396233297)</p>
        <p><AttachEmailIcon/> : brewingbannerproject@gmail.com</p>
        
        <p>&copy; Brewing banner , 2022.            
        </p>
    </div>
  )
}
